// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dialog-module__ui-Dialog--lw1hY {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 10;
}
.Dialog-module__ui-Dialog-Dim--Ot8V2 {
  width: 100%;
  height: 100%;
  background: rgba(9, 10, 12, 0.72);
}

.Dialog-module__ui-Dialog-Container--_tEYU {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #FCFAF7;
  border-radius: 8px;
  padding: 28px 32px 60px;
}

.Dialog-module__ui-Dialog-Close--cCyLp {
  position: absolute;
  top: 30px;
  right: 30px;
}

.Dialog-module__ui-Dialog-Header--OGaWN {
  padding-bottom: 22px;
}

.Dialog-module__title--N_V5w {
  font-size: 2rem; /* 32px */
  font-weight: 600;
  color: #1A1A1A;
}

.Dialog-module__sub-title--BXxlV {
  padding-top: 18px;
  font-size: 0.9375rem; /* 15px */
  color: #666666;
}

.Dialog-module__ui-Dialog-Footer--AXz0s {
  padding-top: 20px;
}

.Dialog-module__ui-Dialog-Container--_tEYU {
  color: #1A1A1A;
}

.Dialog-module__size-medium--EQe0m .Dialog-module__ui-Dialog-Container--_tEYU {
  width: 450px;
}

.Dialog-module__size-large--TMJsq .Dialog-module__ui-Dialog-Container--_tEYU {
  width: 760px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Dialog/Dialog.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;EACT,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe,EAAE,SAAS;EAC1B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB,EAAE,SAAS;EAC/B,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd","sourcesContent":[".ui-Dialog {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n  z-index: 10;\n}\n.ui-Dialog-Dim {\n  width: 100%;\n  height: 100%;\n  background: rgba(9, 10, 12, 0.72);\n}\n\n.ui-Dialog-Container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: #FCFAF7;\n  border-radius: 8px;\n  padding: 28px 32px 60px;\n}\n\n.ui-Dialog-Close {\n  position: absolute;\n  top: 30px;\n  right: 30px;\n}\n\n.ui-Dialog-Header {\n  padding-bottom: 22px;\n}\n\n.title {\n  font-size: 2rem; /* 32px */\n  font-weight: 600;\n  color: #1A1A1A;\n}\n\n.sub-title {\n  padding-top: 18px;\n  font-size: 0.9375rem; /* 15px */\n  color: #666666;\n}\n\n.ui-Dialog-Footer {\n  padding-top: 20px;\n}\n\n.ui-Dialog-Container {\n  color: #1A1A1A;\n}\n\n.size-medium .ui-Dialog-Container {\n  width: 450px;\n}\n\n.size-large .ui-Dialog-Container {\n  width: 760px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-Dialog": `Dialog-module__ui-Dialog--lw1hY`,
	"ui-Dialog-Dim": `Dialog-module__ui-Dialog-Dim--Ot8V2`,
	"ui-Dialog-Container": `Dialog-module__ui-Dialog-Container--_tEYU`,
	"ui-Dialog-Close": `Dialog-module__ui-Dialog-Close--cCyLp`,
	"ui-Dialog-Header": `Dialog-module__ui-Dialog-Header--OGaWN`,
	"title": `Dialog-module__title--N_V5w`,
	"sub-title": `Dialog-module__sub-title--BXxlV`,
	"ui-Dialog-Footer": `Dialog-module__ui-Dialog-Footer--AXz0s`,
	"size-medium": `Dialog-module__size-medium--EQe0m`,
	"size-large": `Dialog-module__size-large--TMJsq`
};
export default ___CSS_LOADER_EXPORT___;
